<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Syllabus'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="13"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Syllabus</div>
          <TabView ref="tabview">
            <TabPanel header="MBA">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-y-5">
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold">Revised in 2019</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <li class="px-4 py-2 border-b border-gray-200 w-full hover:bg-gray-100 hover:text-gray-800"><a
                        href="/static/pdf/mba/syllabus/MBA_Revised_Syllabus_2019.pdf"
                        target="_blank">MBA Revised Syllabus 2019</a></li>
                  </ul>
                </div>
                <div class="flex inline-flex flex-col">
                  <h3 class="p-3 bg-pink-600 w-60 max-w-60 text-white rounded-t-lg font-semibold">Revised in 2016</h3>
                  <ul class="bg-white rounded-b-lg border border-gray-200 w-60 max-w-60 text-gray-600 text-sm font-medium">
                    <li class="px-4 py-2 border-b border-gray-200 w-full hover:bg-gray-100 hover:text-gray-800"><a
                        href="/static/pdf/mba/syllabus/MBA_NEW_Syllabus_2016.pdf"
                        target="_blank">MBA NEW Syllabus 2016</a></li>
                  </ul>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  name: "Syllabus",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped/>
